import {
  Card,
  CardProps,
  CodeViewer,
  CodeViewerProps,
  Divider,
  Flex,
  Tooltip,
  Typography,
} from "djuno-design";
import { ReactComponent as CodeIcon } from "./../assets/icons/code-bracket.svg";
import { ReactComponent as ChevronRightIcon } from "./../assets/icons/chevron-right.svg";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

interface ExpandableCardPros extends CardProps {
  codeViewerProps: CodeViewerProps;
}
const { Text } = Typography;
const ExpandableCard: React.FC<React.PropsWithChildren<ExpandableCardPros>> = ({
  codeViewerProps,
  children,
  ...props
}) => {
  const [showCode, setShowCode] = useState(false);

  return (
    <Card {...props} className="w-full">
      {children}
      <Divider uiType="simple" className="!my-0" />
      <Flex
        direction="row"
        items="center"
        justify="end"
        className="gap-5 w-full"
      >
        <Tooltip
          place="top"
          content={showCode ? "Hide code " : "Show code"}
          theme="black"
        >
          <Text
            onClick={() => setShowCode(!showCode)}
            className="cursor-pointer select-none"
          >
            {showCode ? (
              <ChevronRightIcon className="w-5 -rotate-90" />
            ) : (
              <CodeIcon className="w-5" />
            )}
          </Text>
        </Tooltip>
      </Flex>
      <AnimatePresence>
        {showCode && (
          <motion.div
            className="overflow-hidden"
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
          >
            <CodeViewer
              {...codeViewerProps}
              bgTransparent={codeViewerProps.bgTransparent || true}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Card>
  );
};

export default ExpandableCard;
